import React from 'react';
import MeterProductPage from '../meter-product-page';

import bgImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_background.png';
import logoImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_logo_white.png';
import qrImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_qr_code.jpg';
import productImg from '../../../assets/product-interaction/ddsu5168-4p/ddsu5168_4p.png';

// 临时复用 2P 说明书编号，产品说明书确认后只需替换此地址。
const MANUAL_URL = 'http://m.joymeter.com/manual?code=DDSU5168-700-005';

const DDSU5168FourPole = () => (
  <MeterProductPage
    documentTitle="DDSU5168｜单相导轨式电能表（4P）"
    bgImg={bgImg}
    logoImg={logoImg}
    productImg={productImg}
    qrImg={qrImg}
    model="DDSU5168"
    productName="单相导轨式电能表（4P）"
    slogan="智能通讯 · 稳定计量"
    tags={['RS485', '4G']}
    manualUrl={MANUAL_URL}
    wiringUrl="/product/ddsu5168-4p/wiring"
  />
);

export default DDSU5168FourPole;
